import React from "react";
import styled from "styled-components/macro";
import { Button, Typography } from "@mui/material";
import useAuthStore from "@/store/useAuthStore";
import { useQueryClient } from "react-query";

const Wrapper = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
`;

const SubtitleSmall = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.palette.grey[500]};
  margin-top: 4px;
  margin-bottom: -2px;
`;

const LogoutButton = styled(Button)`
  background-color: ${(props) => props.theme.palette.background.bw};
  font-size: 15px;
  color: ${(props) => props.theme.palette.background.wb};
`;

const ProfileOpen = ({ data }) => {
  const logout = useAuthStore((state) => state.logout);
  const { profile } = data;
  const queryClient = useQueryClient();
  return (
    <Wrapper>
      <Typography sx={{ fontSize: 13, fontWeight: "600" }}>
        User Information
      </Typography>
      <SubtitleSmall>Email</SubtitleSmall>
      <Typography style={{ fontSize: 13, fontWeight: "400", color: "black" }}>
        {profile.email}
      </Typography>
      <SubtitleSmall>Full Name</SubtitleSmall>
      <Typography style={{ fontSize: 13, fontWeight: "400", color: "black" }}>
        {`${profile.first_name} ${profile.last_name}`}
      </Typography>
      <SubtitleSmall>Preferred Language</SubtitleSmall>
      <Typography
        style={{
          fontSize: 13,
          fontWeight: 400,
          color: "black",
          textTransform: "capitalize",
        }}
      >
        {profile.language}
      </Typography>
      <SubtitleSmall>Date of birth</SubtitleSmall>
      <Typography style={{ fontSize: 13, fontWeight: "400", color: "black" }}>
        {profile?.birth_date}
      </Typography>
      <SubtitleSmall>Resides</SubtitleSmall>
      <Typography style={{ fontSize: 13, fontWeight: "400", color: "black" }}>
        {profile?.country?.name}, {profile?.state?.name}
      </Typography>
      {profile?.notes ? (
        <>
          <SubtitleSmall>Notes</SubtitleSmall>
          <Typography
            style={{
              fontSize: 13,
              fontWeight: "400",
              color: "black",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 100,
              overflowY: "auto",
              paddingRight: 6,
            }}
          >
            {profile.notes}
          </Typography>
        </>
      ) : null}
      <LogoutButton
        fullWidth
        variant="contained"
        sx={{ p: 0, mt: 3 }}
        onClick={() => logout(queryClient)}
      >
        Logout
      </LogoutButton>
    </Wrapper>
  );
};

export default ProfileOpen;
